import { Schedule } from "../../../../types/schedule/schedule";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    updateSchedule: Schedule;
  };
}

export const setUpdateScheduleDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { updateSchedule } = action.payload;
  state.updateSchedule = updateSchedule;
};
